module.exports = __webpack_public_path__ + "static/media/investBtn2.e990053e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/investBtn2.png
// module id = 1786
// module chunks = 0 1